export default {
  data () {
    return {
      selected: []
    }
  },

  methods: {
    getSelectedIdx (id) {
      if (this.selected.length === 0) {
        return -1
      }

      return this.selected.map((el) => {
        return el.id
      }).indexOf(id)
    },

    select (item) {
      let idx = this.getSelectedIdx(item.id)
      idx > -1 ? this.selected.splice(idx, 1) : this.selected.push(item)

      return !(idx > -1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Teacher/selectMixin.js